<ng-container *ngIf="type !== null">
    <ng-container [ngSwitch]="type">
        <a
            *ngSwitchCase="'link-menu'"
            [class.outline]="config.fill === 'outline'"
            [class.solid]="config.fill === 'solid'"
            [class.solid-outline]="config.fill === 'solidOutline'"
            [class.bgPrimary]="config.background === 'primary'"
            [class.bgWhite]="config.background === 'white'"
            [class.bgSeparator]="config.background === 'separator'"
            [class.white]="config.textColor === 'white'"
            [class.black]="config.textColor === 'black'"
            [routerLink]="config.url"
            [matMenuTriggerFor]="buttonMenu"
        >
            <app-inner-button [config]="config"></app-inner-button>
        </a>
        <a
            *ngSwitchCase="'link'"
            [class.outline]="config.fill === 'outline'"
            [class.solid]="config.fill === 'solid'"
            [class.solid-outline]="config.fill === 'solidOutline'"
            [class.bgPrimary]="config.background === 'primary'"
            [class.bgWhite]="config.background === 'white'"
            [class.bgSeparator]="config.background === 'separator'"
            [class.white]="config.textColor === 'white'"
            [class.black]="config.textColor === 'black'"
            [routerLink]="config.url"
        >
            <app-inner-button [config]="config"></app-inner-button>
        </a>
        <button
            *ngSwitchCase="'button-menu'"
            [class.outline]="config.fill === 'outline'"
            [class.solid]="config.fill === 'solid'"
            [class.solid-outline]="config.fill === 'solidOutline'"
            [class.bgPrimary]="config.background === 'primary'"
            [class.bgWhite]="config.background === 'white'"
            [class.bgSeparator]="config.background === 'separator'"
            [class.white]="config.textColor === 'white'"
            [class.black]="config.textColor === 'black'"
            [routerLink]="config.url"
            [matMenuTriggerFor]="buttonMenu"
            [disabled]="config.disabled"
            type="button"
        >
            <app-inner-button [config]="config"></app-inner-button>
        </button>
        <button
            *ngSwitchCase="'button'"
            [class.outline]="config.fill === 'outline'"
            [class.solid]="config.fill === 'solid'"
            [class.solid-outline]="config.fill === 'solidOutline'"
            [class.bgPrimary]="config.background === 'primary'"
            [class.bgWhite]="config.background === 'white'"
            [class.bgSeparator]="config.background === 'separator'"
            [class.white]="config.textColor === 'white'"
            [class.black]="config.textColor === 'black'"
            [routerLink]="config.url"
            [disabled]="config.disabled"
            type="button"
        >
            <app-inner-button [config]="config"></app-inner-button>
        </button>
    </ng-container>
    <mat-menu #buttonMenu="matMenu">
        <ng-container *ngIf="config.menu">
            <button
                mat-menu-item
                *ngFor="let option of config.menu.options"
                (click)="menuOptionClick.emit(option.id)"
            >
                {{ option.title }}
            </button>
        </ng-container>
    </mat-menu>
</ng-container>
